import {
  GlobalCertificateNumberField,
  LegalBusinessNameField,
} from "@faire/retailer-visitor-shared/features/IDV/resellerCertificateFields";
import {
  BUSINESS_IDENTIFIER_MAX_CHARS,
  Errors,
  errorTypeToErrorMsg,
  TEXT_INPUT_MAX_CHARS,
} from "@faire/retailer-visitor-shared/features/IDV/validationUtils";
import { useSignUpEventTracker } from "@faire/retailer-visitor-shared/views/SignUp/_hooks/useSignUpEventTracker";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import React, { useMemo } from "react";
import * as Yup from "yup";

export const GlobalResellerCertFields: React.FC<{
  country: string | undefined;
  trackFieldValue: (field: string, value: string) => void;
}> = ({ country }) => {
  const { trackFieldValue } = useSignUpEventTracker(Step.RESELLER_CERT);

  return (
    <>
      <LegalBusinessNameField optional trackChange={trackFieldValue} />
      <Spacer height="4x" />
      <GlobalCertificateNumberField
        optional
        country={country}
        trackChange={trackFieldValue}
      />
    </>
  );
};

export const useGlobalSchema = () => {
  const { strictLocalize } = useStrictLocalization();

  return useMemo(() => {
    return Yup.object().shape({
      legal_business_name: Yup.string().max(
        TEXT_INPUT_MAX_CHARS,
        errorTypeToErrorMsg(strictLocalize).get(
          Errors.TEXT_INPUT_OVER_MAX_CHARS
        )
      ),
      business_identifier: Yup.object().shape({
        identifier_value: Yup.string().max(
          BUSINESS_IDENTIFIER_MAX_CHARS,
          errorTypeToErrorMsg(strictLocalize).get(
            Errors.BUSINESS_IDENTIFIER_OVER_MAX_CHARS
          )
        ),
      }),
    });
  }, [strictLocalize]);
};
